import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledStack = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    & > * ~ * {
        margin-top: 0;
        margin-bottom: 0;
        margin-inline-start: ${props => props.spacing};
        margin-inline-end: 0;
    }
`;
export const HStack = ({ children, spacing, ...props }) => (_jsx(StyledStack, { spacing: spacing, ...props, children: children }));
